<template>
  <div>
    <h3 class="mb-0 d-flex align-items-center">
      Solicitud de Muestrario
      <badge type="info" class="ml-2" style="text-transform: none; letter-spacing: 1px;">{{sb.id}}</badge>
    </h3>
    <hr class="my-3" />

    <div class="row">
      <div class="col-6 mb-2">
        <div class="text-xs font-weight-bold">Solicitado por</div>
        <div class="text-xs text-truncate">{{sb.user}}</div>
      </div>
      <div class="col-6 mb-2">
        <div class="text-xs font-weight-bold">Estatus</div>
        <multiselect
          v-if="[
            'federicoflores@canplast.com.mx',
            'daliahernandez@canplast.com.mx', 
            'leslysifuentes@canplast.com.mx',
            'alfredoreyes@canplast.com.mx'
          ].includes(user.email)"
          :value="status"
          :options="statusOpt"
          label="name"
          :show-labels="false"
          :allow-empty="false"
          @select="changeStatus"

          placeholder="Estatus"
          class="small-multiselect"
          style="width: 150px;"
        />
        <badge v-else :type="status.color" style="font-size: 9px;">{{ status.name }}</badge>
      </div>
      <div class="col-6">
        <div class="text-xs font-weight-bold">Fecha de llegada</div>
        <div class="text-xs">{{sb.estimatedDate}}</div>
      </div>
      <div class="col-6">
        <div class="text-xs font-weight-bold">Fecha de creación</div>
        <div class="text-xs">{{sb.createdDate}}</div>
      </div>
    </div>
    
    <hr class="my-3" />

    <table class="sb-table">
      <thead class="bg-secondary" >
        <tr>
          <th >Tipo</th>
          <th>Motivo</th>
          <th>Descripción</th>
          <th class="text-right">Cantidad</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(req, index) in tableData" :key="index">
          <td>{{ req.type }}</td>
          <td>{{ req.reason }}</td>
          <td>{{ req.refName }}<span v-if="req.refCode"> ({{ req.refCode }})</span></td>
          <td class="text-right">{{ numberFormat(req.quantity) }}</td>
        </tr>
      </tbody>
    </table>

    <hr class="my-3" />

    <div class="d-flex justify-content-end">
      <base-button
        @click="$emit('close')"
        size="sm"
        class="btn btn-danger"
        type="white"
      >
        Cerrar
      </base-button>
    </div>

  </div>
</template>

<script>
import Formats from "@/mixins/Formats.js";
import Multiselect from "vue-multiselect";
import swatchBookStatus from "@/data/swatchBookStatus";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";

export default {
  name: "NewSwatchBook",
  mixins: [Formats],
  components: {
    Multiselect,
  },
  props: {
    sb: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      statusOpt: swatchBookStatus,
      status: null
    };
  },
  methods: {
    changeStatus(status){
      const db = getFirestore();
      const coll = collection(db, "swatch_book_requests");
      const docRef = doc(coll, this.sb.id);
      setDoc(docRef, {status: status.name}, { merge: true })
      .then(() => {
        this.$swal(
          `Estatus ${status.name}`,
          `El estatus ha sido actualizado correctamente`,
          "success",
        ).then(() => {
          this.$emit('success')
        });
      }).catch((error) => {
        console.error("Error", error);
        this.$swal("Error al actualizar", `Ocurrió un error al actualizar el estatus`, "error");
      });
    },
    getStatus(name){
      const status = swatchBookStatus.find(s => s.name === name);
      return status || null;
    }
  },
  computed: {
    tableData(){
      if(!this.sb.types) return [];
      const converted = [];

      this.sb.types.forEach(t => {
        const typeName = t.type;
        t.reasons.forEach(reason => {
          const reasonName = reason.reason;
          reason.refs.forEach(ref => {
            converted.push({
              type: typeName,
              reason: reasonName,
              refCode: ref.refCode || null,
              refName: ref.refName,
              quantity: ref.quantity
            });
          });
        });
      });
      return converted;
    }
  },
  created() {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const { email, displayName } = currentUser;
    this.user = { email, displayName };
    if(!this.sb || !this.sb.id) {
      this.$emit('close');
    }

    this.status = this.getStatus(this.sb.status);
  },
};
</script>

<style lang="scss" scoped>
.sb-table{
  width: 100%;
  color: #525f7f;
}
.sb-table th{
  background-color: #f6f9fc;
}
.sb-table td, .sb-table th{
  font-size: 0.75rem;
  padding: 6px 16px;
}

</style>
